import { Currency } from "@/types/currencies.types"
import { getAllISOByCurrencyOrSymbol, getAllInfoByISO } from "iso-country-currency"

export const getSubscriptionCurrencySymbol = (countryKey: string): Currency => {
  const europeCountries = getAllISOByCurrencyOrSymbol('currency', 'EUR')
  const allowedCurrenciesCountries = [...europeCountries, "SG", "MY"]
  if (!allowedCurrenciesCountries.includes(countryKey?.toUpperCase())) {
    const usCountryInfo = getAllInfoByISO("US")
    return { symbol: usCountryInfo?.symbol, code: usCountryInfo?.currency }
  }

  const countryInfo = getAllInfoByISO(countryKey)
  return { symbol: countryInfo?.symbol, code: countryInfo?.currency }
}
